import { useState } from 'react';
import { sampleSetIcon, sampleSetOfJob } from './sample-set-icons';
const assets = import.meta.glob('./assets/job-icons/*.svg', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>;
const key = 'cpv6-job-identities-v1';
type Registry = { assigned: Record<string, number>; remaining: number[] };
let cached: Registry | undefined;
function registry(): Registry {
  if (cached) return cached;
  try {
    const value = JSON.parse(localStorage.getItem(key) ?? 'null');
    if (value && typeof value.assigned === 'object' && Array.isArray(value.remaining))
      return (cached = value);
  } catch {
    /* Cosmetic identity still works when storage is unavailable. */
  }
  return (cached = { assigned: {}, remaining: [] });
}
export function jobIconIndex(jobId: string): number {
  const state = registry();
  if (Object.prototype.hasOwnProperty.call(state.assigned, jobId)) return state.assigned[jobId];
  if (!state.remaining.length) {
    state.remaining = Array.from({ length: 100 }, (_, i) => i);
    for (let i = 99; i > 0; i--) {
      const random = new Uint32Array(1);
      crypto.getRandomValues(random);
      const j = random[0] % (i + 1);
      [state.remaining[i], state.remaining[j]] = [state.remaining[j], state.remaining[i]];
    }
  }
  const index = state.remaining.pop()!;
  state.assigned[jobId] = index;
  try {
    localStorage.setItem(key, JSON.stringify(state));
  } catch {
    /* Keep the current session's associations. */
  }
  return index;
}
export function JobIdentity({ jobId }: { jobId: string }) {
  // A sample job wears its set's picture, the one on the card that created it.
  const [sampleSet] = useState(() => sampleSetOfJob(jobId));
  const [index] = useState(() => (sampleSet ? 0 : jobIconIndex(jobId)));
  if (sampleSet) {
    const Icon = sampleSetIcon(sampleSet);
    return (
      <span className="job-identity-image sample-identity" aria-hidden="true">
        <Icon strokeWidth={1.4} />
      </span>
    );
  }
  return (
    <img
      className="job-identity-image"
      src={assets[`./assets/job-icons/job-${String(index).padStart(3, '0')}.svg`]}
      alt=""
      aria-hidden="true"
    />
  );
}
